/**
 * Copyright: ThoughtSpot Inc.
 * Author: Vinay kumar nookala (vinay.nookala@thoughtspot.com)
 *
 * @fileoverview
 * This file imports various navigation panels from different MFEs
 * and passes them to the Navigation Hub MFE to render the left navigation under the module tabs.
 */

import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import React, { Suspense } from 'react';
import { lazyWithPreload as lazy } from 'react-lazy-with-preload';
import { useAppContext } from '/@contexts/global-app-context';
import { NavigationHub } from '../../../microfrontends/navigation';
import { Applications } from '../../../routing/routes';
import { getAppModule } from '../../../routing/routes-util';
import { DevelopLeftNavContainer } from '../../embed-dev-portal/develop-left-nav.container';

const NavPanelDataModelContainer = lazy(() =>
    import('../../data-management/nav-panel/nav-panel-data-model.container'),
);

const InsightsNavPanelContainer = lazy(() =>
    import('../../insights/insights-nav-panel.container'),
);

export const LeftNavigationHub = () => {
    const { navService } = useAppContext();

    const getInsightsLeftPanel = () => {
        return (
            <Suspense fallback={<LoadingIndicator />}>
                <InsightsNavPanelContainer />
            </Suspense>
        );
    };

    const getDataLeftPanel = () => {
        return (
            <Suspense fallback={<LoadingIndicator />}>
                <NavPanelDataModelContainer rootPath="/data" />
            </Suspense>
        );
    };

    const getDevelopLeftPanel = () => {
        return (
            <Suspense fallback={<LoadingIndicator />}>
                <DevelopLeftNavContainer />
            </Suspense>
        );
    };

    const goToApplicationHome = (applicationID: string) => {
        if (applicationID === Applications.INSIGHTS) {
            navService.goToUrl('/insights/home');
        } else if (applicationID === Applications.DATA) {
            navService.goToUrl('/data/tables');
        } else {
            navService.goToUrl('/develop');
        }
    };

    return (
        <NavigationHub
            insightsLeftPanelFn={getInsightsLeftPanel}
            dataLeftPanelFn={getDataLeftPanel}
            developLeftPanelFn={getDevelopLeftPanel}
            currentAppModule={getAppModule()}
            goToApplicationHome={goToApplicationHome}
        />
    );
};
